export enum AccessibilityType {
	ALLERGY = 'ALLERGY',
	AUDITIVE = 'AUDITIVE',
	DEMENTIA = 'DEMENTIA',
	MENTAL = 'MENTAL',
	MOTOR = 'MOTOR',
	VISUAL = 'VISUAL',
}

export const ACCESSIBILITY_TYPES_IVV = [AccessibilityType.AUDITIVE, AccessibilityType.MENTAL, AccessibilityType.MOTOR, AccessibilityType.VISUAL];
